import { QueryFilters } from '@tanstack/react-query';
import { DashboardItemDto } from '@unistocks/proxy/axios-client';
import { portfoliosGetQueryKey } from '@unistocks/proxy/axios-client/PortfoliosQuery';

export const queryFilter = ({ settings }: DashboardItemDto): QueryFilters | null =>
  settings.portfolios?.length ? { queryKey: portfoliosGetQueryKey(settings.portfolios[0]) } : null;
